<template>
	<DialogControl :model-value="confirmState.visible" :title="confirmState.title" :icon="confirmState.icon" max-width="480" :attach="overlayTarget" @update:model-value="(open) => !open && closeConfirm(false)">
		<p class="nav-dialog__text mb-0">{{ confirmState.text }}</p>
		<template #actions>
			<v-btn v-if="confirmState.cancelLabel" variant="text" @click="closeConfirm(false)">{{ t(confirmState.cancelLabel) }}</v-btn>
			<v-btn color="primary" variant="tonal" @click="closeConfirm(true)">{{ t(confirmState.confirmLabel) }}</v-btn>
		</template>
	</DialogControl>
</template>

<script setup>
import { inject } from 'vue';
import DialogControl from '@/components/controls/DialogControl.vue';
import { usePromoStep } from '@/composables/usePromoStep';

const { confirmState, closeConfirm, t } = usePromoStep();
const overlayTarget = inject('overlayTarget', null);
</script>
